export default __webpack_public_path__ + "static/media/ACGR SCORECARD for 2023.bc89122f.pdf";